/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBurstingDefinitionError = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.53 2.152a1 1 0 0 0-1.06 0l-8 5A1 1 0 0 0 3 8v8a1 1 0 0 0 .47.848l8 5a1 1 0 0 0 1.06 0l.916-.573a5.974 5.974 0 0 1-.443-2.081l-.003.002v-5.642l6-3.75V13c.701 0 1.374.12 2 .341V8a1 1 0 0 0-.47-.848zM5 15.446V9.804l6 3.75v5.642zM18.113 8 12 11.82 5.887 8 12 4.18z" />
        <path d="M19 23a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-2.05-5.343.707-.708 3.394 3.394-.707.708z" />
      </g>
    </g>
  </Icon>
);
export { SvgBurstingDefinitionError as BurstingDefinitionError };
